export default __webpack_public_path__ + "static/media/together.96733e60.png";